export const validate = (validations, values) => {
  const obj = {};
  
  for(const [k, v] of Object.entries(values)) {
    const invalidateRules = validations[k].filter(validateRule => validateRule.rule.test(v) !== validateRule.match);
    
    invalidateRules.length > 0 && (obj[k] = invalidateRules[0].message);
  }
  
  return {
    isValid: Object.keys(obj).length === 0,
    errors: Object.keys(obj).length > 0 ? obj : {}
  }
}